module.exports = __webpack_public_path__ + "portal-static/img/img_ico.2e35134c.png";